import { Component, ViewEncapsulation, Input } from '@angular/core';

import { Node } from '@alfresco/js-api';

import { WkCompareService } from '../../services/wk-compare.service';
import { imageResolver } from '../../utils/image-resolver.utils';

@Component({
  selector: 'wk-content-node-selector-widget',
  templateUrl: './wk-content-node-selector-widget.component.html',
  styleUrls: ['./wk-content-node-selector-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'adf-content-node-selector-widget' },
  standalone: false,
})
export class WkContentNodeSelectorWidgetComponent {
  @Input()
  chosenNodes: Node[];
  @Input()
  parentFolderId;
  @Input()
  currentFileId;

  imageResolveFunction = imageResolver;

  constructor(private readonly compareService: WkCompareService) {}

  onSelect(nodeList: Node[]) {
    this.chosenNodes = nodeList;
    this.compareService.chosenNodes.next(this.chosenNodes);
  }

  transform = (node: Node) => {
    if (node && node.path && node.path.elements) {
      const elements = node.path.elements;

      if (elements.length > 1) {
        elements[1].name === 'Sites' && elements.splice(1, 1);
        elements[0].name === 'Company Home' && elements.splice(0, 1);
      }
    }

    return node;
  };
}
